import { masterAxios } from 'api/config'
import { useQuery } from '@tanstack/react-query'
import { DefaultQuestion } from 'types/default-question'

export const DEFAULT_QUESTIONS_QUERY_KEY = 'default-questions'

export const fetchDefaultQuestions = async (areaIds?: string[]): Promise<DefaultQuestion[]> => {
  const body = areaIds?.length ? { areaIds } : undefined
  const { data } = await masterAxios.patch<DefaultQuestion[]>('default-questions/areas', body, {
    params: { sort: 'order' },
  })
  return data
}

export const useGetDefaultQuestions = (areaIds?: string[]) => {
  const { data, ...result } = useQuery({
    queryKey: [DEFAULT_QUESTIONS_QUERY_KEY, [...(areaIds ?? [])].sort().join(',')],
    queryFn: () => fetchDefaultQuestions(areaIds),
    staleTime: 5 * 60 * 1000,
    gcTime: Infinity,
  })

  return {
    defaultQuestions: data ?? [],
    ...result,
  }
}
